import React, { useState } from "react";
import { SlidersHorizontal } from "lucide-react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { CardHeadeWithActions } from "../components/ui";
import { LevelSettings } from "./settings/LevelSettings";

const SettingMenuItem = ({ item, active, onClick }) => {
  const Icon = item.icon;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex w-full items-center gap-3 rounded-xl px-3 py-3 text-start !text-[12px] font-bold transition-colors ${
        active ? "bg-[#261759] text-white" : "text-[#261759] hover:bg-slate-100"
      }`}
    >
      <Icon size={18} />
      <span>{item.title}</span>
    </button>
  );
};

export const Settings = () => {
  const [t] = useTranslation("global");
  const isRtl = i18next.dir(i18next.language) === "rtl";
  const sections = [
    {
      id: "levels",
      title: t("setting.LevelSettings"),
      icon: SlidersHorizontal,
    },
  ];
  const [selected, setSelected] = useState(sections[0].id);
  const selectedSection =
    sections.find((item) => item.id === selected) || sections[0];

  return (
    <section className="relative p-2 font-normal" dir={isRtl ? "rtl" : "ltr"}>
      <CardHeadeWithActions
        wImage="w-5"
        title={t("menu.settings")}
        icon="/assets/icons/gear.png"
      />

      <div className="mt-4 grid grid-cols-12 gap-2">
        <aside className="col-span-3 rounded-2xl border border-slate-200 bg-white p-3 shadow-sm">
          <div className="space-y-1">
            {sections.map((item) => (
              <SettingMenuItem
                key={item.id}
                item={item}
                active={selected === item.id}
                onClick={() => setSelected(item.id)}
              />
            ))}
          </div>
        </aside>
            {selectedSection.id === "levels" && <LevelSettings  title={selectedSection?.title}/>}
      </div>
    </section>
  );
};
